import React from 'react';
import './connectionTests.css';
import { Button } from 'reactstrap';
import ConnectionComponent from './ConnectionTestInfo';
import PreferredProviderTest from './PreferredProviderTest';
import { format } from 'date-fns';
import ConnectionPingControls from './ConnectionPingControls';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
function ConnectionTests({
  speedBox,
  onDetailBtn,
  speedTestInfo,
  speedDataInfo,
  speedBoxDisable,
  boxVpnAddress,
  onReloadBox,
  boxDC,
  user
}) {
  const cellSignalCheck = getPermissionForComponent('cellSignalCheck', user.permissionsGroup);
  const timeFormate = () => {
    const timeStamp = speedBox?.Timestamp;
    const splited = timeStamp.split(' ');
    const newDate = splited[0] + 'T' + splited[1] + 'Z';
    return format(new Date(newDate), 'MM/dd/yyyy HH:mm:ss');
  };

  const speedBoxData = [
    { name: 'DATE', value: speedBox?.Timestamp && timeFormate() },
    { name: 'IMEI', value: speedBox?.IMEI },
    { name: 'Active SIM', value: speedBox?.SimICCID },
    { name: 'MTM', value: speedBox?.TelMobileNum },
    { name: 'LTE Max Latency', value: speedBox?.LatencyMax },
    { name: 'LTE Avg Latency', value: speedBox?.LatencyAvg },
    { name: 'LTE Min Latency', value: speedBox?.LatencyMin },
    { name: 'LTE Avg RSSI', value: speedBox?.RssiAvg },
    // { name: 'LTE TCP Upload', value: speedBox?.UploadTCP },
    // { name: 'LTE TCP Download', value: speedBox?.DownloadTCP },
    // { name: 'LTE UDP Upload', value: speedBox?.UploadUDP },
    // { name: 'LTE UDP Download', value: speedBox?.DownloadUDP },
  ];

  const speedTestInfoData = [
    { name: 'Latency', value: speedTestInfo?.latency },
    { name: 'Jitter', value: speedTestInfo?.jitter },
    { name: 'Upload Speed', value: speedTestInfo?.uploadSpeed },
    { name: ' Download Speed', value: speedTestInfo?.downloadSpeed },
  ];

  const speedDataInfoData = [
    { name: 'Upload Speed', value: speedDataInfo?.uploadSpeed },
    { name: ' Download Speed', value: speedDataInfo?.downloadSpeed },
  ];
  return (
    <div className="connectionTestsTabScroll">
      <div className="connectionsContainer">
        <div className="row">
          <div className="col-6" md={6}>
            <ConnectionComponent
              onReload={() => onDetailBtn('4g')}
              conectionTestDetails={speedBox && speedBoxData}
              heading="4G LTE Check "
              speedBoxInProgress={speedBox?.inProgress}
            />
          </div>
          <div className="col-6" md={6}>
            <ConnectionComponent
              onReload={() => onDetailBtn('voice')}
              conectionTestDetails={speedTestInfo && speedTestInfoData}
              heading="Voice Speed Check "
            />
          </div>

          <div className="col-6" md={6}>
            <ConnectionComponent
              onReload={() => onDetailBtn('data')}
              conectionTestDetails={speedDataInfo && speedDataInfoData}
              heading="Data Speed Check"
            />
          </div>
          <div className="col-6" md={6}>
            <PreferredProviderTest boxVpnAddress={boxVpnAddress} boxDC={boxDC} />
          </div>
        </div>
      </div>
      {(cellSignalCheck === 'write' || cellSignalCheck === 'both') && (
        <ConnectionPingControls vpnAddress={boxVpnAddress} />
      )}
      <div className='row'>
        <div className="connectionButtonsContainer">       

          <div className='col-md-4'>
          <Button
            disabled={speedBoxDisable}
            className="connectionButton-75"
            id="data-check-tip"
            color="primary"
            onClick={() => onDetailBtn('eth0')}
          >
            <strong>Ping from Eth0</strong>  
          </Button>
          </div>
          <div className='col-md-4'>

          <Button
            className="connectionButton-75 "
            id="voice-check-tip"
            color="primary"
            onClick={() => onDetailBtn('wwan0')}
          >
            <strong>Ping from WWan0</strong>    
          </Button>
          </div>
          <div className='col-md-4'>
          <Button
            className="connectionButton-75"
            id="data-check-tip"
            color="primary"
            onClick={() => onDetailBtn('wlan0')}
          >
            <strong>Ping from WLan0</strong>  
          </Button>
          </div>
      
        </div>
        </div>
        <div className='row'>
        <div className="connectionButtonsContainer">       

            <div className='col-md-4'>     
          <Button
            disabled={speedBoxDisable}
            className="connectionButton-75"
            id="data-check-tip"
            color="primary"
            onClick={() => onDetailBtn('fetcheth0')}
          >
          <strong>Fetch Eth0 Results</strong> 
          </Button>
          </div>
        <div className='col-md-4 '>     
        <Button
          className="connectionButton-75"
          id="voice-check-tip"
          color="primary"
          onClick={() => onDetailBtn('fetchwwan0')}
        >
         <strong>Fetch WWan0 Results</strong>  
        </Button>
        </div>
        <div className='col-md-4'>     
        <Button
          className="connectionButton-75 "
          id="data-check-tip"
          color="primary"
          onClick={() => onDetailBtn('fetchwlan0')}
        >
         <strong> Fetch WLan0 Results</strong> 
        </Button>
      </div>
      </div>
    </div>
    </div>
  );
}

export default ConnectionTests;
